import React from 'react'
import PropTypes from 'prop-types'
import { v4 as uuid } from 'uuid'

import CtaButton from '@cred/react-cta'
import { highYieldSavings } from '@cred/react-analytics/contexts'
import { ctaClick } from '@cred/react-analytics/events'
import { withSnowplowContexts } from '@cred/react-analytics/SnowplowContextManager'
import { EffectiveDate } from '@cred/react-rate'

import DisclosureModal from 'multi-vertical/rate-table/components/disclosure-modal'

import styles from './styles.module.scss'
import disclaimers from '../components/disclaimers/disclaimers'
import { getMMMDDFormat } from '../../utils'

const HighYieldTile = ({
  slug,
  name,
  ctaUrl,
  apy,
  minimumBalance,
  displayOrder,
  estimatedSavings,
  balanceAmount,
  trackSnowplowEvent,
  vertical,
  productName,
}) => {
  const spName = (provider, spVertical) => {
    const spProvider = {
      high_yield_savings: {
        wealthfront: 'Wealthfront',
        nationwide: 'NationwideMySavings',
        discover: 'Discover',
        citi: 'Citi',
      },
      interest_checking: {
        axosdirect: 'AxosRewardsChecking',
      },
    }
    return spProvider[spVertical][provider]
  }
  const onCtaClick = () => {
    const trackingId = uuid()
    trackSnowplowEvent(
      ctaClick,
      {
        text: `Learn More on ${name}'s website`,
        activated: true,
      },
      [
        highYieldSavings.analytics({
          providerName: spName(slug, vertical),
          apy,
          trackingId,
          estEarnings: estimatedSavings,
          balanceAmount: `$${balanceAmount}`,
          displayOrder: `${displayOrder}`,
        }),
      ],
    )

    window.open(ctaUrl(trackingId), '_blank')
  }
  const ratesQuery = {
    format: getMMMDDFormat,
    rateType: 'apy',
    vertical: 'high_yield_savings',
    variable: true,
    name: 'rate',
    lenderSlug: slug,
  }
  return (
    <div className={`${styles.container} mt-8`}>
      <div className={styles.tileInfoSection}>
        <div className={styles.lenderSection}>
          <div className={styles.logoSection}>
            <div className={`${styles.logo} ${styles[slug]}`} />
          </div>
          <div className={styles.middleSection}>
            <div className={styles.apySection}>
              <p className="disclaimer">APY</p>
              <p className="disclaimer">
                as of <EffectiveDate {...ratesQuery} />
              </p>
              <p className="heading semiBold">{apy}%</p>
            </div>
            <div className={styles.minBalSection}>
              <p className="disclaimer">Minimum balance required to earn APY</p>
              <p className="heading semiBold">${minimumBalance}</p>
            </div>
          </div>
          <div className={styles.ctaSection}>
            <CtaButton target="_blank" onClick={onCtaClick} size="small">
              Learn More
            </CtaButton>
            <p className={`${styles.texts} disclaimer mt-8 align-center `}>on {name}'s website</p>
          </div>
        </div>
      </div>
      <div className={styles.bottomBar}>
        <div className={styles.barLeftSection}>
          <p className={[styles.actType, styles.xSmallFont, 'ml-sm-8', 'semiBold'].join(' ')}>
            {productName}
          </p>
          <div className={styles.fdicSection}>
            <p className={styles.xSmallFont}>Member FDIC</p>
          </div>
        </div>
        <div className={styles.barRightSection}>
          <DisclosureModal
            className={styles.xSmallFont}
            title={slug === 'wealthfront' ? 'Details & Disclosure' : 'View Details'}
            name={`${vertical}-${slug}`}
            vertical="savings"
          >
            {disclaimers(slug, vertical, apy)}
          </DisclosureModal>
        </div>
      </div>
    </div>
  )
}

HighYieldTile.propTypes = {
  slug: PropTypes.string,
  name: PropTypes.string,
  ctaUrl: PropTypes.func,
  minimumBalance: PropTypes.number,
  displayOrder: PropTypes.number,
  balanceAmount: PropTypes.number,
  apy: PropTypes.string,
  estimatedSavings: PropTypes.string,
  trackSnowplowEvent: PropTypes.func,
  vertical: PropTypes.string,
  productName: PropTypes.string,
  theme: PropTypes.string,
}

export { HighYieldTile }
export default withSnowplowContexts(HighYieldTile)
